import { Dom } from "@/lib/utils/dom"

ko.bindingHandlers["multilineText"] =
   init: ->
      # Prevent binding on the dynamically-injected HTML
      return { "controlsDescendantBindings": true }

   update: (element, valueAccessor) ->
      $(element).html(Dom.convertTextToHtml(ko.unwrap(valueAccessor())))